import {merge} from 'lodash';
import partnerMessages from '@i18n_messages_en-US'

import components from './en-US/components'
import views from './en-US/views'
import db from './en-US/db';
import navbar from './en-US/navbar';
import navigation from './en-US/navigation';
import breadcrumbs from './en-US/breadcrumbs';
import orders from './en-US/orders';
import widget from './en-US/widget';
import quiz from './en-US/quiz';
import modal from './en-US/modal';
import errors from './en-US/errors';
import products from './en-US/products';
import checkout_config from './en-US/checkout_config';
import approval_config from './en-US/approval_config';
import catalog from './en-US/catalog';
import footer from './en-US/footer';

const result = {
    components,
    db,
    navbar,
    views,
    navigation,
    breadcrumbs,
    orders,
    widget,
    quiz,
    modal,
    errors,
    products,
    checkout_config,
    approval_config,
    catalog,
    footer,
    networkIssuesHeader: 'Issues connecting to the Gear services',
    networkIssues: 'Sorry, we\'re having trouble connecting to Gear services. Make sure you are disconnected from the VPN before continuing.'
};

export default merge(result, partnerMessages)